/* tslint:disable */
import zenObservable from 'zen-observable';
export var Observable = zenObservable;